import React from 'react';
import Stripe from 'stripe';
import { isDevEnv } from 'common/utils/common';
import { SetUpButton } from './SetupButton';
import { useTranslation } from 'services/localization';
import Banner from 'components/Banner';

interface Props {
	account: Stripe.Account;
}

export const ActionRequiredBanner = ({ account }: Props) => {
	const { t } = useTranslation();
	const detailsSubmitted = account.details_submitted;
	const chargesEnabled = account.charges_enabled || isDevEnv();
	const accountId = account.id;

	return !detailsSubmitted ? (
		<Banner
			variant="warning"
			title={t('common:prompts.actionRequired', 'Action required')}
			description={t(
				'account.payments.stripePaymentInfoNeeded',
				'Stripe needs more information to complete your payment account',
			)}
			buttonEl={
				<SetUpButton
					accountId={accountId}
					text={t('settings.completeSetup', 'Complete setup')}
					variant="text"
				/>
			}
		/>
	) : !chargesEnabled ? (
		<Banner
			variant="warning"
			title={t(
				'account.payments.paymentsDisabledFromAccount',
				'Payments are disabled from your account',
			)}
		/>
	) : null;
};
